export default {
  set (key, val) {
    return localStorage.setItem(key, val ? JSON.stringify(val) : null)
  },
  get (key) {
    const value = localStorage.getItem(key)
    
    try {
      return value ? JSON.parse(value) : null
    } catch (error) {
      return value
    }
  },
  remove (key) {
    return localStorage.removeItem(key)
  },
  removeAll () {
    return localStorage.clear()
  }
}
